﻿export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options
}
